import { isAxiosError } from "axios"
import { useStation, useError, useUser, useLocation } from "@/app/store"
import * as Sentry from "@sentry/nextjs"

export const sample:Function = (
    list: any[]
) => {
    return list[Math.floor(Math.random() * list.length)]
}

export const throttle = (
    action: Function,
    delay: number
) => {
    let timer: ReturnType<typeof setTimeout> = null
    return (...args: any) => {
        if (timer) return
        timer = setTimeout(() => {
            action(...args)
            timer = null
        }, delay)
    }
}
export const random = (
    min: number,
    max: number,
    decimals: number
) => {
    const str = (Math.random() * (max - min) + min).toFixed(decimals)
    return parseFloat(str)
}
export const findRoute = (shortcut: string) => 
    useStation.getState()?.data?.find((e: any) => e.shortcut === shortcut)

export const findStation = (shortcut: string) =>
    useStation.getState()?.data.flatMap((r: any) => r.station_set)?.find((s: any) => s.shortcut === shortcut)

export const reportError = (error: any, errorPage?: boolean) => {
    const account = useUser.getState().data.account
    const geo = useLocation.getState().geo
    const weather = useLocation.getState().weather
    const user = {
        name: account?.name,
        token: account?.token,
        location: JSON.stringify(geo, null, 4),
        weather: JSON.stringify(weather, null, 4),
    }
    const extraMsg = isAxiosError(error) ? {
        request: {
            url: error.config?.url,
            method: error.config?.method,
            params: error.config?.params,
            data: error.config?.data,
        },
        response: {
            status: error.response?.status,
            data: error.response?.data,
        },
        user: user
    } : {
        error: error.message || error,
        user: user
    }

    useError.setState({debugMsg: extraMsg})

    const eventId = Sentry.captureException(error, {
        extra: extraMsg,
    })

    if (errorPage) {
        useError.setState({sentryEventId: eventId})
    }
}
  